import React, { Component } from 'react';
import ProjectSignpost from './ProjectSignpost'

class ProjectSlideshow extends Component {

    render() {
        let slides = []
        const { projects } = this.props
        
        if (projects.length) {
            projects.map(project => {
                return slides.push(
                    <ProjectSignpost project={project} isActive={this.props.currentTab === project.slug} key={project.slug} />
                );
            });
        }

        return (
            <div ref="slideshow" className="c-project-slideshow">
                {slides}
            </div>
        )

    }

}

export default ProjectSlideshow;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectSlideshow.js